import { useQuery } from '@tanstack/react-query';

import pageRepository from '@/features/pages/repositories/PageRepository';
import { usePageStore } from '@/features/pages/stores/usePageStore';
import { pageKeys } from '@/shared/query/queryKeys';

/**
 * Query-backed read path for the currently open page.
 *
 * The store holds only the open page's id; the page data itself lives in the
 * query cache under pageKeys.detail, so mutations and sync refresh it through
 * normal invalidation instead of copying objects into Zustand.
 */
export function useCurrentPage() {
  const currentPageId = usePageStore(state => state.currentPageId);

  return useQuery({
    queryKey: pageKeys.detail(currentPageId ?? ''),
    // Query data must not be undefined; a missing page is null
    queryFn: async () => (await pageRepository.getPageById(currentPageId ?? '')) ?? null,
    enabled: !!currentPageId,
  });
}
